import Vue from "vue";
import Es6Promise from 'es6-promise';
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./assets/css/initialize.css";
import vant from "vant";
import "vant/lib/index.css";
import { mixins } from "./mixin/index";
import Bridge from "@/utils/dsbridge";
// import "@/utils/rem";
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';
Vue.mixin(mixins);
Vue.config.productionTip = false;
Vue.prototype.$bridge = Bridge;
// var userAgent = window.navigator.userAgent;
// if (userAgent && userAgent.indexOf("{") != -1) {
//   const jsonStart = userAgent.indexOf("{");
//   const jsonEnd = userAgent.lastIndexOf("}");
//   const json = userAgent.substring(jsonStart, jsonEnd + 1);
//   const data = JSON.parse(json);
//   console.log("useAgent-main", data);
//   Vue.prototype.$wxPay = data.openId =='app_d3391c9af9734396a297a0c71b98533b'
// } else{
//   Vue.prototype.$wxPay =  false
// }
Vue.prototype.$wxPay = false;
Vue.prototype.$zfbPay = false;
Vue.prototype.$ylPay = false;
Vue.use(vant);
Vue.prototype.$tippy = tippy;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

Es6Promise.polyfill()